import { ObjectMapper } from "json-object-mapper";

export class InsightVacationModel {
  
  static create(input: any): InsightVacationModel {
    return ObjectMapper.deserialize<InsightVacationModel>(InsightVacationModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}